/**
 * Landing page copy. Frozen + namespaced for future i18n. Shared CTA labels
 * come from copy/common.js so button text stays consistent site-wide.
 * @typedef {Readonly<Record<string, any>>} CopyMap
 */
import { CTA } from "./common";

/** @type {CopyMap} */
export const HERO = Object.freeze({
  badge: "THE AI-NATIVE LINK PLATFORM",
  kicker: "CREATE · ROUTE · ANALYZE · UNDERSTAND · SCALE",
  headline: Object.freeze(["One all-in-one link platform.", "Unlimited AI potential."]),
  // subtitle rendered with an inline emphasis on `emphasis`
  subtitleLead: "Create ",
  subtitleEmphasis: "short links, QR codes, and bio pages",
  subtitleTail:
    " — then let LinkLane's AI explain your analytics in plain English, build links from a sentence, flag what needs you, and apply the fix in one click. The link platform that doesn't just understand what you're doing — it helps you do it.",
  trust: Object.freeze(["No credit card", "Free forever plan", "AI on every paid plan"]),
  ctaPrimary: CTA.startFree,
  ctaSecondary: CTA.viewPlans,
});

/** @type {CopyMap} */
export const FINAL_CTA = Object.freeze({
  badge: "GO TIME",
  title: "The front door to",
  titleAccent: "your whole link stack.",
  subtitle:
    "Create, manage, route, analyze, and scale every link from one place. Free forever. No card. Your first lane in under 30 seconds.",
  ctaPrimary: CTA.startFree,
  ctaSecondary: CTA.viewPlans,
});

export default Object.freeze({ HERO, FINAL_CTA });
